var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-flex",
                    { staticClass: "mt-2", attrs: { xl2: "", md2: "" } },
                    [
                      _vm._v(" User Token "),
                      _c("span", { staticClass: "error--text" }, [_vm._v("*")]),
                    ]
                  ),
                  _c("v-flex", { attrs: { xl6: "", md8: "" } }, [
                    _c(
                      "div",
                      { staticClass: "flex flex-col items-end" },
                      [
                        _c("v-text-field", {
                          staticClass: "w-full",
                          attrs: {
                            rules: _vm.tokenRules,
                            autofocus: "",
                            outlined: "",
                            dense: "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.debounceCheckToken($event)
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("v-fade-transition", [
                                    _c(
                                      "div",
                                      { staticClass: "mt-1" },
                                      [
                                        _vm.icon
                                          ? _c("v-img", {
                                              attrs: {
                                                src: _vm.icon,
                                                height: "16",
                                                eager: "",
                                                contain: "",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.form.token,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "token", $$v)
                            },
                            expression: "form.token",
                          },
                        }),
                        _c("save-change-button", {
                          attrs: {
                            state: _vm.state,
                            disabled: !_vm.valid || !_vm.validToken,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }